import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import { useEffect, useState } from "react";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import Loader from "../../CustomComponents/Loader/Loader";

const VendorDetailsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const { propertyData, addressData } = location.state || {};
  const [propertyDetails, setPropertyDetails] = useState(propertyData || {});
  const [addressDetails, setAddressDetails] = useState(addressData || {});
  const vendorToken = localStorage.getItem("token");

  const mainFilters = [
    { label: "General Details", value: `/vendor/property/edit/${id}?` },
    { label: "Rooms", value: `/vendor/property/all-rooms/${id}?` },
    { label: "Inventory", value: `/vendor/property/inventory/${id}` },
    { label: "Rates", value: `/vendor/property/rates/${id}` },
    { label: "Policies", value: `/vendor/property/rules/${id}` },
  ];

  const fetchPropertyData = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/crud/edit/${id}`,
        requestOptions
      );
      const result = await response.json();

      if (response.ok) {
        setPropertyDetails({
          ...result.data,
          featured: result.data.featured ? "1" : "0",
          online: result.data.online ? "1" : "0",
        });
        setAddressDetails({
          address: result.data.address,
          latitude: "",
          longitude: "",
          country: result.data.country,
          state: result.data.state,
          city: result.data.city,
        });
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching property data:", err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPropertyData();
    }
  }, [id]);

  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  return (
    <div className="sidebar_main_div new_sidebar_main_div">
      <SideBar allPropertiesPage={false} />
      <div className="agent-info-container" style={{ height: "100%" }}>
        <VendorHeader showSelectProperty={true} vendorProperty={false} />

        <section>
          <div className="">
            <div className="bg-white-div mt-10">
              {loader ? (
                <Loader size="4em" color="#009A50" />
              ) : (
                <>
                  <div className="flex_align_center flex_gap_20 ">
                    <span
                      onClick={() => window.history.back()}
                      className="vendor_back_btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ margin: "0" }}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <mask
                          id="mask0_7233_11440"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            width="24"
                            height="24"
                            transform="matrix(-1 0 0 1 24 0)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_7233_11440)">
                          <path
                            d="M7.373 12.75H18.75C18.9628 12.75 19.141 12.6782 19.2845 12.5345C19.4282 12.391 19.5 12.2128 19.5 12C19.5 11.7872 19.4282 11.609 19.2845 11.4655C19.141 11.3218 18.9628 11.25 18.75 11.25H7.373L12.5423 6.08076C12.6909 5.93209 12.7643 5.75809 12.7625 5.55876C12.7605 5.35942 12.682 5.18217 12.527 5.02701C12.3718 4.88217 12.1962 4.80717 12 4.80201C11.8038 4.79684 11.6282 4.87184 11.473 5.02701L5.13275 11.3673C5.03908 11.4609 4.97308 11.5597 4.93475 11.6635C4.89625 11.7673 4.877 11.8795 4.877 12C4.877 12.1205 4.89625 12.2327 4.93475 12.3365C4.97308 12.4403 5.03908 12.5391 5.13275 12.6328L11.473 18.973C11.6115 19.1115 11.783 19.1823 11.9875 19.1855C12.192 19.1887 12.3718 19.1178 12.527 18.973C12.682 18.8178 12.7595 18.6397 12.7595 18.4385C12.7595 18.2372 12.682 18.0589 12.527 17.9038L7.373 12.75Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    </span>
                    <div>
                      <div className="flex flex_gap_5 align_items_center flex_wrap">
                        {" "}
                        <h4 className="text-left text-capitalize">
                          {propertyDetails.name || ""}
                        </h4>{" "}
                        <span
                          className={`rating ${
                            propertyDetails?.starRating === 1 ||
                            propertyDetails?.starRating === 2
                              ? "low"
                              : propertyDetails?.starRating === 3
                              ? "mid"
                              : propertyDetails?.starRating === 4 ||
                                propertyDetails?.starRating === 5
                              ? "high"
                              : ""
                          }`}
                        >
                          <svg
                            width="14"
                            height="13"
                            viewBox="0 0 14 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z"
                              fill="white"
                            />
                          </svg>
                          {propertyDetails?.starRating || ""} Star
                        </span>
                      </div>
                      <small className="text-uppercase font_12 align_top">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_7208_10146"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="18"
                            height="18"
                          >
                            <rect width="18" height="18" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_7208_10146)">
                            <path
                              d="M9.00216 8.89894C9.37528 8.89894 9.69428 8.76606 9.95916 8.50031C10.2242 8.23456 10.3567 7.91512 10.3567 7.542C10.3567 7.16887 10.2238 6.84981 9.95803 6.58481C9.69228 6.31994 9.37278 6.1875 8.99953 6.1875C8.62641 6.1875 8.30741 6.32038 8.04253 6.58613C7.77753 6.85188 7.64503 7.17138 7.64503 7.54463C7.64503 7.91775 7.77791 8.23675 8.04366 8.50163C8.30941 8.7665 8.62891 8.89894 9.00216 8.89894ZM9.00084 14.6351C10.4681 13.3216 11.5909 12.0618 12.3693 10.8555C13.1477 9.64925 13.5368 8.59275 13.5368 7.686C13.5368 6.31875 13.1025 5.19475 12.2337 4.314C11.365 3.43325 10.2873 2.99287 9.00084 2.99287C7.71434 2.99287 6.63672 3.43325 5.76797 4.314C4.89922 5.19475 4.46484 6.31875 4.46484 7.686C4.46484 8.59275 4.85403 9.64925 5.63241 10.8555C6.41078 12.0618 7.53359 13.3216 9.00084 14.6351ZM9.00084 16.1321C7.11334 14.4966 5.69797 12.9746 4.75472 11.5659C3.81147 10.1572 3.33984 8.86387 3.33984 7.686C3.33984 5.95525 3.89966 4.55406 5.01928 3.48244C6.13903 2.41081 7.46622 1.875 9.00084 1.875C10.5355 1.875 11.8627 2.41081 12.9824 3.48244C14.102 4.55406 14.6618 5.95525 14.6618 7.686C14.6618 8.86387 14.1902 10.1572 13.247 11.5659C12.3037 12.9746 10.8883 14.4966 9.00084 16.1321Z"
                              fill="#888888"
                            />
                          </g>
                        </svg>
                        {addressDetails.city || ""},{" "}
                        {addressDetails.state || ""}
                      </small>
                    </div>
                  </div>
                  {/* <div className="filter_section">
                    <div className="container_inside">
                      <div className="filter_wrapper">
                        {mainFilters.map((item, index) => {
                          const isActive =
                            location.pathname === item.value.replace("?", "");

                          return (
                            <Link
                              to={item.value}
                              key={index}
                              className={`filter_card ${isActive ? "active_filter" : ""
                                }`}
                            >
                              {item.label}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div> */}
                </>
              )}
            </div>
            <Outlet />
          </div>
        </section>
      </div>
    </div>
  );
};

export default VendorDetailsLayout;
